module.exports = __webpack_public_path__ + "static/media/AppScreenshot.784cf9f8.png";